import React, { ReactNode } from "react";
import { usePermission } from "@/hooks/usePermission";

export interface PermissionGuardProps {
  permission?: string;
  role?: string;
  fallback?: ReactNode;
  children: ReactNode;
}

/**
 * Guarda de renderização de componentes com base no RBAC do usuário.
 * Oculta botões de ação ou seções restritas da interface.
 */
export const PermissionGuard: React.FC<PermissionGuardProps> = ({
  permission,
  role,
  fallback = null,
  children,
}) => {
  const { hasPermission, hasRole } = usePermission();

  if (permission && !hasPermission(permission)) {
    return <>{fallback}</>;
  }

  if (role && !hasRole(role)) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
};
